import { ReactNode } from "react";
import { PlainNavLink } from "styles/elements";
import {
  PanelContainer,
  PanelContent,
  PanelHeader,
  PanelLoadingSpinner,
} from "./styles";

export type PanelContentType = "normal" | "information" | "warning";
export type PanelPaddingType = "none" | "padded" | "square";

interface Props {
  children: ReactNode;
  header?: string;
  type?: PanelContentType;
  padding?: PanelPaddingType;
  bottomMargin?: boolean;
  loading?: boolean;
  navLink?: string;
}

export const Panel = ({
  children,
  header,
  type,
  padding,
  bottomMargin,
  loading,
  navLink,
}: Props) => {
  const panelContainer = (
    <PanelContainer bottomMargin={bottomMargin ?? true}>
      {!!header && <PanelHeader>{header}</PanelHeader>}
      <PanelContent
        type={type ?? "normal"}
        padding={padding ?? "none"}
        hoverStyling={!!navLink}
      >
        {loading ? <PanelLoadingSpinner /> : <>{children}</>}
      </PanelContent>
    </PanelContainer>
  );

  return !!navLink ? (
    <PlainNavLink to={navLink}>{panelContainer}</PlainNavLink>
  ) : (
    panelContainer
  );
};
